import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, DeviceFullDTO, FrameDTO, PlayerCullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { PermissionService } from '../../../../services/permission.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SbDateTime, SbLocalDateTime } from '../../../../services/api/api-date-time';
import { DateTime, Duration } from 'luxon';

@Component({
  selector: 'sb-page-device-details-activity',
  templateUrl: './device-details-activity.component.html',
  styleUrls: ['./device-details-activity.component.scss'],
  standalone: false,
})
export class DeviceDetailsActivityComponent implements OnInit {
  deviceId: number;
  device: DeviceFullDTO;

  cullsLoading: boolean;

  culls: PlayerCullDTO[];
  notes: string;

  _from?: SbLocalDateTime;
  get from(): SbLocalDateTime {
    return this._from;
  }

  set from(val) {
    this._from = val;
  }

  _till?: SbLocalDateTime;
  get till(): SbLocalDateTime {
    return this._till;
  }

  set till(val) {
    this._till = val;
  }

  onlineStateData: FrameDTO[] = [];
  airtimeData: FrameDTO[] = [];
  interval: number = 3600;
  timespan: Duration;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.deviceId = undefined;
    this.device = undefined;
    this.cullsLoading = true;
    this.culls = null;
    this.from = new SbLocalDateTime(DateTime.local().startOf('day').minus({ day: 8 }));
    this.till = new SbLocalDateTime(DateTime.local().startOf('day').minus({ day: 1 }));
    this.timespan = DateTime.fromJSDate(this.util.localDateToJSDate(this.till)).diff(
      DateTime.fromJSDate(this.util.localDateToJSDate(this.from)),
      'days'
    );
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;

      this.getOnlineStateData();
      this.getAirtimeData();
    });
  }

  refresh() {
    this.timespan = DateTime.fromJSDate(this.util.localDateToJSDate(this.till)).diff(
      DateTime.fromJSDate(this.util.localDateToJSDate(this.from)),
      'days'
    );
    this.getOnlineStateData();
    this.getAirtimeData();
  }

  getOnlineStateData() {
    if (!this.permissionService.hasPermission(this.permissionService.Permission.ss_nm_reporting)) {
      return;
    }
    this.api
      .ss_nm_Reporting_deviceStatusCountHistory({
        from: new SbDateTime(this.from.value),
        till: new SbDateTime(this.till.value),
        interval: this.interval,
        device: this.deviceId ? [this.deviceId] : null,
      })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: data => {
          this.onlineStateData = data?.buckets?.[0]?.frames ?? [];
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  getAirtimeData() {
    if (!this.permissionService.hasPermission(this.permissionService.Permission.ss_nm_reporting)) {
      return;
    }
    this.api
      .ss_nm_Reporting_airtimeQuota({
        from: this.from,
        till: this.till,
        interval: this.interval,
        device: this.deviceId ? [this.deviceId] : null,
      })
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: data => {
          this.airtimeData = data?.buckets?.[0]?.frames ?? [];
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  handleDateChangeFrom(date: SbLocalDateTime) {
    this.from = date;
  }

  handleDateChangeTill(date: SbLocalDateTime) {
    this.till = date;
  }
}
